/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ApiResult,
    CreateVehicleRequest,
    CumulativeSessionCostResponse,
    EnergyConsumptionResponse,
    LinkRfidTagsRequest,
    SessionCountResponse,
    UnlinkRfidTagsRequest,
    UpdateVehicleRequest,
    VehicleDto,
} from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    CreateVehicleRequestFromJSON,
    CreateVehicleRequestToJSON,
    CumulativeSessionCostResponseFromJSON,
    CumulativeSessionCostResponseToJSON,
    EnergyConsumptionResponseFromJSON,
    EnergyConsumptionResponseToJSON,
    LinkRfidTagsRequestFromJSON,
    LinkRfidTagsRequestToJSON,
    SessionCountResponseFromJSON,
    SessionCountResponseToJSON,
    UnlinkRfidTagsRequestFromJSON,
    UnlinkRfidTagsRequestToJSON,
    UpdateVehicleRequestFromJSON,
    UpdateVehicleRequestToJSON,
    VehicleDtoFromJSON,
    VehicleDtoToJSON,
} from "../models/index";

export interface CreateVehicleOperationRequest {
    body?: CreateVehicleRequest;
}

export interface GetCumulativeSessionCostRequest {
    vehicleId: number;
    from: string;
    to: string;
    interval: GetCumulativeSessionCostIntervalEnum;
}

export interface GetVehicleRequest {
    vehicleId: number;
}

export interface GetVehicleChargeSessionCountRequest {
    vehicleId: number;
    from: string;
    to: string;
    interval: GetVehicleChargeSessionCountIntervalEnum;
}

export interface GetVehicleCumulativeEnergyConsumptionRequest {
    vehicleId: number;
    from: string;
    to: string;
    interval: GetVehicleCumulativeEnergyConsumptionIntervalEnum;
}

export interface GetVehicleModelsRequest {
    make?: Array<string>;
}

export interface LinkRfidTagsOperationRequest {
    vehicleId: number;
    body?: LinkRfidTagsRequest;
}

export interface UnlinkRfidTagsOperationRequest {
    vehicleId: number;
    body?: UnlinkRfidTagsRequest;
}

export interface UpdateVehicleOperationRequest {
    vehicleId: number;
    body?: UpdateVehicleRequest;
}

/**
 *
 */
export class VehiclesHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Create a new vehicle. Status defaults to Active if omitted.
     */
    async createVehicleRaw(
        requestParameters: CreateVehicleOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/vehicles`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: CreateVehicleRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Create a new vehicle. Status defaults to Active if omitted.
     */
    async createVehicle(
        requestParameters: CreateVehicleOperationRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.createVehicleRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get the cost of charge sessions that started in a time period, aggregated by the requested interval, for a vehicle
     */
    async getCumulativeSessionCostRaw(
        requestParameters: GetCumulativeSessionCostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<CumulativeSessionCostResponse>> {
        if (requestParameters["vehicleId"] == null) {
            throw new runtime.RequiredError(
                "vehicleId",
                'Required parameter "vehicleId" was null or undefined when calling getCumulativeSessionCost().',
            );
        }

        if (requestParameters["from"] == null) {
            throw new runtime.RequiredError(
                "from",
                'Required parameter "from" was null or undefined when calling getCumulativeSessionCost().',
            );
        }

        if (requestParameters["to"] == null) {
            throw new runtime.RequiredError(
                "to",
                'Required parameter "to" was null or undefined when calling getCumulativeSessionCost().',
            );
        }

        if (requestParameters["interval"] == null) {
            throw new runtime.RequiredError(
                "interval",
                'Required parameter "interval" was null or undefined when calling getCumulativeSessionCost().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["interval"] != null) {
            queryParameters["interval"] = requestParameters["interval"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/vehicles/{vehicleId}/cumulative-charge-session-cost`.replace(
                    `{${"vehicleId"}}`,
                    encodeURIComponent(String(requestParameters["vehicleId"])),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            CumulativeSessionCostResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get the cost of charge sessions that started in a time period, aggregated by the requested interval, for a vehicle
     */
    async getCumulativeSessionCost(
        requestParameters: GetCumulativeSessionCostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<CumulativeSessionCostResponse> {
        const response = await this.getCumulativeSessionCostRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get a single vehicle by id.
     */
    async getVehicleRaw(
        requestParameters: GetVehicleRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<VehicleDto>> {
        if (requestParameters["vehicleId"] == null) {
            throw new runtime.RequiredError(
                "vehicleId",
                'Required parameter "vehicleId" was null or undefined when calling getVehicle().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/vehicle/{vehicleId}`.replace(
                    `{${"vehicleId"}}`,
                    encodeURIComponent(String(requestParameters["vehicleId"])),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            VehicleDtoFromJSON(jsonValue),
        );
    }

    /**
     * Get a single vehicle by id.
     */
    async getVehicle(
        requestParameters: GetVehicleRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<VehicleDto> {
        const response = await this.getVehicleRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get the count of charge sessions that started in a time period, aggregated by the requested interval, for the requested vehicle
     */
    async getVehicleChargeSessionCountRaw(
        requestParameters: GetVehicleChargeSessionCountRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<SessionCountResponse>> {
        if (requestParameters["vehicleId"] == null) {
            throw new runtime.RequiredError(
                "vehicleId",
                'Required parameter "vehicleId" was null or undefined when calling getVehicleChargeSessionCount().',
            );
        }

        if (requestParameters["from"] == null) {
            throw new runtime.RequiredError(
                "from",
                'Required parameter "from" was null or undefined when calling getVehicleChargeSessionCount().',
            );
        }

        if (requestParameters["to"] == null) {
            throw new runtime.RequiredError(
                "to",
                'Required parameter "to" was null or undefined when calling getVehicleChargeSessionCount().',
            );
        }

        if (requestParameters["interval"] == null) {
            throw new runtime.RequiredError(
                "interval",
                'Required parameter "interval" was null or undefined when calling getVehicleChargeSessionCount().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["interval"] != null) {
            queryParameters["interval"] = requestParameters["interval"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/vehicles/{vehicleId}/charge-session-count`.replace(
                    `{${"vehicleId"}}`,
                    encodeURIComponent(String(requestParameters["vehicleId"])),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            SessionCountResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get the count of charge sessions that started in a time period, aggregated by the requested interval, for the requested vehicle
     */
    async getVehicleChargeSessionCount(
        requestParameters: GetVehicleChargeSessionCountRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<SessionCountResponse> {
        const response = await this.getVehicleChargeSessionCountRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get Cumulative energy consumption history in Wh for a time period, aggregated by the requested interval, for the requested vehicle
     */
    async getVehicleCumulativeEnergyConsumptionRaw(
        requestParameters: GetVehicleCumulativeEnergyConsumptionRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<EnergyConsumptionResponse>> {
        if (requestParameters["vehicleId"] == null) {
            throw new runtime.RequiredError(
                "vehicleId",
                'Required parameter "vehicleId" was null or undefined when calling getVehicleCumulativeEnergyConsumption().',
            );
        }

        if (requestParameters["from"] == null) {
            throw new runtime.RequiredError(
                "from",
                'Required parameter "from" was null or undefined when calling getVehicleCumulativeEnergyConsumption().',
            );
        }

        if (requestParameters["to"] == null) {
            throw new runtime.RequiredError(
                "to",
                'Required parameter "to" was null or undefined when calling getVehicleCumulativeEnergyConsumption().',
            );
        }

        if (requestParameters["interval"] == null) {
            throw new runtime.RequiredError(
                "interval",
                'Required parameter "interval" was null or undefined when calling getVehicleCumulativeEnergyConsumption().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["interval"] != null) {
            queryParameters["interval"] = requestParameters["interval"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/vehicles/{vehicleId}/cumulative-energy`.replace(
                    `{${"vehicleId"}}`,
                    encodeURIComponent(String(requestParameters["vehicleId"])),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            EnergyConsumptionResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get Cumulative energy consumption history in Wh for a time period, aggregated by the requested interval, for the requested vehicle
     */
    async getVehicleCumulativeEnergyConsumption(
        requestParameters: GetVehicleCumulativeEnergyConsumptionRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<EnergyConsumptionResponse> {
        const response = await this.getVehicleCumulativeEnergyConsumptionRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Returns a distinct sorted list of vehicle makes accessible to the current user. Suitable for use as a filter/dropdown data source.
     */
    async getVehicleMakesRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/vehicles/makes`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns a distinct sorted list of vehicle makes accessible to the current user. Suitable for use as a filter/dropdown data source.
     */
    async getVehicleMakes(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<string>> {
        const response = await this.getVehicleMakesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns a distinct sorted list of vehicle models accessible to the current user. Pass \'make\' to filter by one or more makes. Suitable for use as a filter/dropdown data source.
     */
    async getVehicleModelsRaw(
        requestParameters: GetVehicleModelsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        if (requestParameters["make"] != null) {
            queryParameters["make"] = requestParameters["make"]!.join(
                runtime.COLLECTION_FORMATS["csv"],
            );
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/vehicles/models`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns a distinct sorted list of vehicle models accessible to the current user. Pass \'make\' to filter by one or more makes. Suitable for use as a filter/dropdown data source.
     */
    async getVehicleModels(
        requestParameters: GetVehicleModelsRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<string>> {
        const response = await this.getVehicleModelsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Link one or more RFID cards to a vehicle.
     */
    async linkRfidTagsRaw(
        requestParameters: LinkRfidTagsOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["vehicleId"] == null) {
            throw new runtime.RequiredError(
                "vehicleId",
                'Required parameter "vehicleId" was null or undefined when calling linkRfidTags().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/vehicles/{vehicleId}/rfid-tags`.replace(
                    `{${"vehicleId"}}`,
                    encodeURIComponent(String(requestParameters["vehicleId"])),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: LinkRfidTagsRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Link one or more RFID cards to a vehicle.
     */
    async linkRfidTags(
        requestParameters: LinkRfidTagsOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.linkRfidTagsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Unlink one or more RFID cards from a vehicle. Does not delete the RFID tags.
     */
    async unlinkRfidTagsRaw(
        requestParameters: UnlinkRfidTagsOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["vehicleId"] == null) {
            throw new runtime.RequiredError(
                "vehicleId",
                'Required parameter "vehicleId" was null or undefined when calling unlinkRfidTags().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/vehicles/{vehicleId}/rfid-tags`.replace(
                    `{${"vehicleId"}}`,
                    encodeURIComponent(String(requestParameters["vehicleId"])),
                ),
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
                body: UnlinkRfidTagsRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Unlink one or more RFID cards from a vehicle. Does not delete the RFID tags.
     */
    async unlinkRfidTags(
        requestParameters: UnlinkRfidTagsOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.unlinkRfidTagsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Update a vehicle. Pass Status = Inactive or Archived to deactivate/archive.
     */
    async updateVehicleRaw(
        requestParameters: UpdateVehicleOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["vehicleId"] == null) {
            throw new runtime.RequiredError(
                "vehicleId",
                'Required parameter "vehicleId" was null or undefined when calling updateVehicle().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/vehicles/{vehicleId}`.replace(
                    `{${"vehicleId"}}`,
                    encodeURIComponent(String(requestParameters["vehicleId"])),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: UpdateVehicleRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Update a vehicle. Pass Status = Inactive or Archived to deactivate/archive.
     */
    async updateVehicle(
        requestParameters: UpdateVehicleOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.updateVehicleRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * OData endpoint listing vehicles visible to the current user.
     */
    async vehiclesODataRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<VehicleDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/vehicles`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(VehicleDtoFromJSON),
        );
    }

    /**
     * OData endpoint listing vehicles visible to the current user.
     */
    async vehiclesOData(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<VehicleDto>> {
        const response = await this.vehiclesODataRaw(initOverrides);
        return await response.value();
    }
}

/**
 * @export
 */
export const GetCumulativeSessionCostIntervalEnum = {
    Minute: "minute",
    Hour: "hour",
    Day: "day",
    Week: "week",
    Month: "month",
} as const;
export type GetCumulativeSessionCostIntervalEnum =
    (typeof GetCumulativeSessionCostIntervalEnum)[keyof typeof GetCumulativeSessionCostIntervalEnum];
/**
 * @export
 */
export const GetVehicleChargeSessionCountIntervalEnum = {
    Minute: "minute",
    Hour: "hour",
    Day: "day",
    Week: "week",
    Month: "month",
} as const;
export type GetVehicleChargeSessionCountIntervalEnum =
    (typeof GetVehicleChargeSessionCountIntervalEnum)[keyof typeof GetVehicleChargeSessionCountIntervalEnum];
/**
 * @export
 */
export const GetVehicleCumulativeEnergyConsumptionIntervalEnum = {
    Minute: "minute",
    Hour: "hour",
    Day: "day",
    Week: "week",
    Month: "month",
} as const;
export type GetVehicleCumulativeEnergyConsumptionIntervalEnum =
    (typeof GetVehicleCumulativeEnergyConsumptionIntervalEnum)[keyof typeof GetVehicleCumulativeEnergyConsumptionIntervalEnum];
